var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3004 5.67571H11.3554C11.0859 5.67571 10.8623 5.45216 10.8623 5.18258C10.8623 4.913 11.0859 4.68945 11.3554 4.68945H15.3004C15.57 4.68945 15.7936 4.913 15.7936 5.18258C15.7936 5.45216 15.57 5.67571 15.3004 5.67571Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78085 5.67571H2.15084C1.88127 5.67571 1.65771 5.45216 1.65771 5.18258C1.65771 4.913 1.88127 4.68945 2.15084 4.68945H4.78085C5.05042 4.68945 5.27397 4.913 5.27397 5.18258C5.27397 5.45216 5.05042 5.67571 4.78085 5.67571Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41059 7.97744C5.87204 7.97744 4.61621 6.72161 4.61621 5.18305C4.61621 3.6445 5.87204 2.38867 7.41059 2.38867C8.94915 2.38867 10.205 3.6445 10.205 5.18305C10.205 6.72161 8.94915 7.97744 7.41059 7.97744ZM7.41059 3.37492C6.41119 3.37492 5.60246 4.18365 5.60246 5.18305C5.60246 6.18246 6.41119 6.99118 7.41059 6.99118C8.41 6.99118 9.21872 6.18246 9.21872 5.18305C9.21872 4.18365 8.41 3.37492 7.41059 3.37492Z",
    fill: "#828282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3004 12.9091H12.6704C12.4008 12.9091 12.1772 12.6856 12.1772 12.416C12.1772 12.1464 12.4008 11.9229 12.6704 11.9229H15.3004C15.57 11.9229 15.7935 12.1464 15.7935 12.416C15.7935 12.6856 15.57 12.9091 15.3004 12.9091Z",
    fill: "#828282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09585 12.9091H2.15084C1.88127 12.9091 1.65771 12.6856 1.65771 12.416C1.65771 12.1464 1.88127 11.9229 2.15084 11.9229H6.09585C6.36543 11.9229 6.58898 12.1464 6.58898 12.416C6.58898 12.6856 6.36543 12.9091 6.09585 12.9091Z",
    fill: "#828282"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0405 15.2099C8.50192 15.2099 7.24609 13.954 7.24609 12.4155C7.24609 10.8769 8.50192 9.62109 10.0405 9.62109C11.579 9.62109 12.8349 10.8769 12.8349 12.4155C12.8349 13.954 11.579 15.2099 10.0405 15.2099ZM10.0405 10.6073C9.04107 10.6073 8.23235 11.4161 8.23235 12.4155C8.23235 13.4149 9.04107 14.2236 10.0405 14.2236C11.0399 14.2236 11.8486 13.4149 11.8486 12.4155C11.8486 11.4161 11.0399 10.6073 10.0405 10.6073Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIcon);
export default __webpack_public_path__ + "static/media/status-icon.c0e6a2f0e65e889cd365eafc52810b7f.svg";
export { ForwardRef as ReactComponent };